import $ from 'jquery';

$.addInit(function(context){
	var base = '.b-fixedActions';
	$(base, context).each(function(){
		var component = $(this);

		var goTop = component.find(base + '-goTop');
		goTop.removeClass('m-active');

		$(window).scroll(function () {
			if ($(this).scrollTop() > 500) {
				goTop.addClass('m-active');
			} else {
				goTop.removeClass('m-active');
			}
		});

		goTop.click(function () {
			$('body,html').animate({
				scrollTop: 0
			}, 500);

			return false;
		});
	});
});


//////////////////
// WEBPACK FOOTER
// ./src/components/b-fixedActions.js
// module id = 37
// module chunks = 0